import { State } from '../state';

export const SierraDeviceSelectors = {
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    deviceRegistration: (state: State) => state.SierraDevice,
    exerthermUnitIdValidation: (state: State): boolean => state.SierraDevice.exerthermUnitIdValidation,
};
